import {
  queryContentLangs,
  translateContentLangs,
  updateContentLangs,
} from '@admin/api/common/lang/index'

export default function useLangField({ langOptions, siteCodeRef }) {
  const fields = reactive({})
  const model = ref({})
  const loading = ref(false)
  watch(
    () => [model.value],
    () => {
      console.log('~', model.value)
    },
    { deep: true },
  )
  const addField = (fieldId, context) => {
    fields[fieldId] = context
  }
  const delField = (fieldId) => {
    delete fields[fieldId]
  }

  const addContent = (content) => {
    if (!model.value[content.contentId]) {
      model.value[content.contentId] = { ...content, langs: {} }
      queryContentLang(content.contentId)
    }
  }

  const updateContenLang = (contentId, lang, langVal) => {
    model.value[contentId].langs[lang] = langVal
  }

  const queryContentLang = async (contentId) => {
    try {
      loading.value = true
      const { content, field } = model.value[contentId]
      const params: any = { content, field, site_code: siteCodeRef.value }

      const { data } = await queryContentLangs(params)
      ;(data.langs || []).forEach((item) => {
        model.value[contentId].langs[item.locale] = item.content
      })
    } finally {
      loading.value = false
    }
  }

  const translateContentLang = async (contentId, lang) => {
    try {
      loading.value = true
      const { content, field } = model.value[contentId]
      const params: any = { content, key: field }
      if (lang) {
        params.langs = [lang]
      } else {
        params.langs = langOptions.value.map((option) => option.value)
      }
      const { data } = await translateContentLangs(params)
      ;(data || []).forEach((item) => {
        model.value[contentId].langs[item.lang] = item.content
      })
    } finally {
      loading.value = false
    }
  }
  const submit = async () => {
    const params: any = { site_code: siteCodeRef.value, items: [] }
    params.items = Object.values(toRaw(fields)).map((getContent: any) => {
      const { content, contentId, field } = getContent()
      const langs = model.value[contentId]?.langs || {}
      const newLangs = Object.keys(langs).map((key) => ({ locale: key, content: langs[key] }))
      return {
        field,
        content,
        langs: newLangs,
      }
    })
    await updateContentLangs(params)
    model.value = {}
  }
  return {
    loading,
    addField,
    delField,
    addContent,
    updateContenLang,
    queryContentLang,
    translateContentLang,
    submit,
    model,
  }
}
